import { ValueObject } from '@nx-smartmonkey/shared/domain';
import { Subscription } from '../subscription/Subscription';
import { ProjectResources } from './ProjectResources';

export interface OrganizationResourcesProps {
  organization_id: string;
  subscription: Subscription;
  projects: ProjectResources[];
  users: number;
}

export class OrganizationResources extends ValueObject<OrganizationResourcesProps> {
  get organization_id(): string {
    return this.props.organization_id;
  }

  get subscription(): Subscription {
    return this.props.subscription;
  }

  get projects(): ProjectResources[] {
    return this.props.projects;
  }

  private constructor(props: OrganizationResourcesProps) {
    super(props);
  }

  static create(props: OrganizationResourcesProps): OrganizationResources {
    return new OrganizationResources(props);
  }

  getProjectResources(projectId: string): ProjectResources | undefined {
    return this.props.projects.find((project) => project.project_id === projectId);
  }
}
